import React, {Component} from 'react';
import './App.css';
import moment from "moment";
import "moment/locale/es";
import WeekDates from "./components/week_dates";
import WeekModel from "./components/week_model";
import EndPoint, {api} from "./rest";
import swal from "sweetalert2";
import Loading from "./components/loading";
import FormBus from "./components/form_bus";
import FormModel from "./components/form_model";
import FormService from "./components/form_service";
import FormEdit from "./components/form_edit";
import FormContractor from "./components/form_contractor";
import FormEditContractor from "./components/form_edit_contractor"
import FormServiceRoute from "./components/form_service_route";
import Modal from "./components/modal";
import io from "socket.io-client";
import FormEditModel from "./components/form-edit-model";
import FormEditBus from "./components/form-edit-bus";
import Mousetrap from "./mousetrap";
import {DragDropContext} from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import LoadingStore from "./stores/LoadingStore";
import ServicesStore from "./stores/ServicesStore";
import AuthStore from "./stores/AuthStore";
import ModalStore from "./stores/ModalStore";


class App extends Component {
	constructor(props) {
		super(props);
		let now = moment(AuthStore.date.time);
		let from = now.clone().weekday(0).add(-1,"w");
		let to = now.clone().weekday(6).add(1,"w");
		let deltaDays = Math.abs(from.clone().diff(to.clone(),"day")) + 1;
		this.state = {
			sticky: false,
			busDay: null,
			from,
			to,
			now,
			deltaDays,
			fetching: LoadingStore.getState(),
			filter: "",
			active: "",
			data: [],
			modelId: "",
			openId: "",
			busId: "",
			lp: AuthStore.user.permission_level,
			container: "",
			contractors: []
		};
		this.nextWeek = this.nextWeek.bind(this);
		this.prevWeek = this.prevWeek.bind(this);
		this.handleJumpChange = this.handleJumpChange.bind(this);
		this.handleFilterChange = this.handleFilterChange.bind(this);
		this.setBusDay = this.setBusDay.bind(this);
		this.requestModels = this.requestModels.bind(this);
		this.enterFullscreen = this.enterFullscreen.bind(this);
	}
	enterFullscreen () {
		let i = this.appFull;
		if (i.requestFullscreen) {
			i.requestFullscreen();
		} else if (i.webkitRequestFullscreen) {
			i.webkitRequestFullscreen();
		} else if (i.mozRequestFullScreen) {
			i.mozRequestFullScreen();
		} else if (i.msRequestFullscreen) {
			i.msRequestFullscreen();
		}
	}
	componentWillMount() {
		Mousetrap.bind("mod+x", e => {
			ModalStore.openModal("form-service");
		});
		Mousetrap.bind("esc", e => {
			ModalStore.closeModal();
		});
		Mousetrap.bind("left", e => {
			if (!this.state.fetching) {
				this.prevWeek();
			}
		});
		Mousetrap.bind("right", e => {
			if (!this.state.fetching) {
				this.nextWeek();
			}
		});

		if(window.location.hostname === "localhost") {
			this.socket = io("localhost:9000", {path: "/wss"});
		} else {
			this.socket = io("https://calendar.kaoz.space", {path: "/wss", secure: true});
		}

		this.socket.on('bus-rt:update', () => {
			this.requestModels();
		});

		this.requestModels(true);
		LoadingStore.on("change", ()=> {
			this.setState({fetching: LoadingStore.getState()})
		});
		LoadingStore.on("reload", ()=> {
			this.requestModels();

		})
	}

	componentDidMount() {
		this.setState({container: (document.body.clientHeight - this._container.getBoundingClientRect().top) + "px"});
		window.addEventListener("resize", ()=> {
			this.setState({container: (document.body.clientHeight - this._container.getBoundingClientRect().top) + "px"});
		});
		this.dates = document.querySelector(".app-dates");
		this.top = this.dates.getBoundingClientRect().top;
		this.body = document.body;
		// Returns a function, that, as long as it continues to be invoked, will not
		// be triggered. The function will be called after it stops being called for
		// N milliseconds. If `immediate` is passed, trigger the function on the
		// leading edge, instead of the trailing.
		function debounce(func, wait, immediate) {
			var timeout;
			return function () {
				var context = this, args = arguments;
				var later = function () {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		}
		window["app-calendar"].onscroll = debounce(() => {
			// let pixelWidthOf1em = parseFloat(getComputedStyle(window["app-calendar"]).fontSize);
			console.log("scroll left",window["app-calendar"].scrollLeft);
			console.log("vs", window["app-calendar"].scrollWidth - window["app-calendar"].offsetWidth);
			/*
			GET SCROLL WIDTH
			 window["app-calendar"].scrollWidth
			 SUBSTRACT OFFSET WIDTH
			 - window["app-calendar"].offsetWidth
			 ADD
			 + parseFloat(getComputedStyle(window["app-calendar"]).fontSize)
			 */

			if (!this.state.fetching) {
				if (window["app-calendar"].scrollLeft >= (window["app-calendar"].scrollWidth - window["app-calendar"].offsetWidth)) {
					this.lastWidth = {
						isEnd: true,
						value: window["app-calendar"].scrollWidth - window["app-calendar"].offsetWidth
					};
					this.increaseTo();
				}
				if (window["app-calendar"].scrollLeft === 0) {
					this.lastWidth = {
						isEnd: false,
						value: window["app-calendar"].scrollWidth - window["app-calendar"].offsetWidth
					};
					this.increaseFrom();
				}
			}
		}, 50)
	}

	fixToCenter() {
		window["app-calendar"].scrollLeft = (window["app-calendar"].scrollWidth / 3);
	}

	fixToOld () {
		if (this.lastWidth.isEnd) {
			window["app-calendar"].scrollLeft = this.lastWidth.value;
		} else {
			window["app-calendar"].scrollLeft = window["app-calendar"].scrollWidth - window["app-calendar"].offsetWidth - this.lastWidth.value;
		}
	}

	getChildContext() {
		return {
			getColor: (id) => {
				let result = this.state.contractors.find(contractor => contractor.id == id);
				return result ? result.color : false;
			},
			setActive: (id) => {
				this.setState({active: id});
				ModalStore.openModal("form-edit");
			},
			getActive: () => {
				return this.state.active;
			},
			getOpenId: () => {
				return this.state.openId;
			},
			setOpenId: (openId, extra) => {
				ModalStore.openModal(openId);
				this.setState({...extra});
			},
			getLp: () => {
				return this.state.lp;
			}
		}
	}

	closeModal() {
		this.setState({openId: null});
	}

	openModal(id) {
		this.setState({openId: id});
	}

	calculateDeltaDays () {
		this.setState({
			deltaDays: Math.abs(this.state.from.clone().diff(this.state.to.clone(),"day")) + 1
		},()=>{
			this.requestModels(false,true)
		})
	}

	increaseFrom () {
		this.setState({
			from: this.state.from.clone().add(-1,"w").weekday(0)
		},this.calculateDeltaDays);
	}

	increaseTo () {
		this.setState({
			to: this.state.to.clone().add(1,"w").weekday(6)
		},this.calculateDeltaDays)
	}

	requestModels(initial=false,fixToOld=false) {
		this.setState({fetching: true});
		api.get("contractors")
			.then((response)=>{
				this.setState({contractors: response.data});
				LoadingStore.emit("reload-colors");
			})
			.catch((error)=>{
				console.error(error);
			});
		EndPoint.API.get("/models", {
			params: {
				from: this.state.from.format("YYYY-MM-DD 00:00:00"),
				to: this.state.to.format("YYYY-MM-DD 23:59:59"),
			}
		})
		.then(({data})=> {
			this.setState({
				data,
				fetching: false
			},()=>{
				if (initial) {
					this.fixToCenter();
				}if (fixToOld) {
					this.fixToOld();
				}
			});
			ServicesStore.setServices(data);
		})
		.catch((error)=> {
			if (error.response) {
				swal("Error", `Status: ${error.response.status}`, "error");
			} else {
				swal("Error", `El servidor no respondio en tiempo o en forma`, "error");
			}
			console.error(error);
			this.setState({fetching: false});
		})
	}
	//http://stackoverflow.com/questions/8917921/cross-browser-javascript-not-jquery-scroll-to-top-animation
	scrollTo(element, to, duration) {
		var start = element.scrollLeft,
			change = to - start,
			increment = 20;

		var animateScroll = (elapsedTime) => {
			elapsedTime += increment;
			var position = this.easeInOut(elapsedTime, start, change, duration);
			element.scrollLeft = position;
			if (elapsedTime < duration) {
				setTimeout(function() {
					animateScroll(elapsedTime);
				}, increment);
			}
		};

		animateScroll(0);
	}
	//http://stackoverflow.com/questions/8917921/cross-browser-javascript-not-jquery-scroll-to-top-animation
	easeInOut(currentTime, start, change, duration) {
		currentTime /= duration / 2;
		if (currentTime < 1) {
			return change / 2 * currentTime * currentTime + start;
		}
		currentTime -= 1;
		return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
	}

	nextWeek() {
		let to = window["app-calendar"].scrollLeft + ((window["app-calendar"].scrollWidth - window["app-calendar"].offsetWidth) / this.state.deltaDays) * 8

		this.scrollTo(window["app-calendar"],to,150);
	}

	prevWeek() {
		let to = window["app-calendar"].scrollLeft - ((window["app-calendar"].scrollWidth - window["app-calendar"].offsetWidth) / this.state.deltaDays) * 8
		this.scrollTo(window["app-calendar"],to,150);
	}

	handleJumpChange({target}) {
		if (!target.value) {
			return;
		}
		let now = moment(target.value);
		let from = now.clone().weekday(0).add(-1,"w");
		let to = now.clone().weekday(6).add(1,"w");
		let deltaDays = Math.abs(from.clone().diff(to.clone(),"day")) + 1;
		this.setState({
			now,
			from,
			to,
			deltaDays
		},()=>{
			this.requestModels(true);
		});
	}

	handleFilterChange({target}) {
		this.setState({filter: target.value});
	}

	setBusDay(busDay) {
		this.setState({busDay});
	}

	render() {
		let models;
		let dates = {
			from: this.state.from,
			to: this.state.to,
			deltaDays: this.state.deltaDays,
			now: this.state.now
		};
		let busDayHelper = {
			busDay: this.state.busDay,
			setBusDay: this.setBusDay
		};
		let filter = this.state.data.map(({id, name}, i)=> {
			return <option key={i} value={id}>{name}</option>
		});
		if (this.state.filter !== "") {
			if (this.state.filter == 0) {
				models = this.state.data.filter(({external})=> !external).map((model)=> {
					return <WeekModel key={model.name} {...model} dates={dates} busDay={busDayHelper}/>
				});
			} else if (this.state.filter == -1) {
				models = this.state.data.filter(({external})=> external).map((model)=> {
					return <WeekModel key={model.name} {...model} dates={dates} busDay={busDayHelper}/>
				});
			} else {
				models = this.state.data.filter(({id})=>id == this.state.filter).map((model)=> {
					return <WeekModel key={model.name} {...model} dates={dates} busDay={busDayHelper}/>
				});
			}

		} else {
			models = this.state.data.map((model)=> {
				return <WeekModel key={model.name} {...model} dates={dates} busDay={busDayHelper}/>
			});
		}
		return (
			<div>
				<div className="app-control row small-12">
					<div className="columns small-12 control-calendar">
						<div className="row">
							<label className="columns medium-2 small-12">
								<em> </em>
								<button type="button" className="button expanded" disabled={this.state.fetching}
										onClick={this.prevWeek}>Regresar una semana
								</button>
							</label>
							<label className="columns medium-2 small-12">
								<em>Filtro</em>
								<select value={this.state.filter} onChange={this.handleFilterChange}>
									<option value="">Todos</option>
									<option value={0}>Propios</option>
									<option value={-1}>Externos</option>
									{filter}
								</select>
							</label>
							<label className="columns medium-2 small-12">
								<em> </em>
								<button type="button" className="button expanded success"
										onClick={this.requestModels.bind(this,false,false)}>
									Actualizar
								</button>
							</label>
							<label className="columns medium-2 small-12">
								<em> </em>
								<button type="button" className="button expanded warning"
										onClick={this.enterFullscreen}>
									Pantalla Completa
								</button>
							</label>
							<label className="columns medium-2 small-12">
								<em>Saltar</em>
								<input type="date" value={this.state.now.format("YYYY-MM-DD")}
									   disabled={this.state.fetching} onChange={this.handleJumpChange}/>
							</label>
							<label className="columns medium-2 small-12">
								<em> </em>
								<button type="button" className="button expanded" disabled={this.state.fetching}
										onClick={this.nextWeek}>Avanzar una semana
								</button>
							</label>
						</div>
					</div>
				</div>
				<div className="small-12" id="app-calendar-full" ref={(ref)=>this.appFull = ref}>
					<div className={`app-dates`}>
						<div className="dates-reference">
							<div className="camiones">Camiones</div>
							<div className="fechas">Fechas</div>
						</div>
						<WeekDates dates={dates}/>
					</div>
					<div id="app-calendar" className="small-12" ref={(c) => this._container = c}
						 style={{height: this.state.container}}>
						{models}
					</div>
					<Loading loading={this.state.fetching}/>
					<Modal id={"form-edit"}>
						<FormEdit data={this.state.data} contratantes={this.state.contractors} update={this.requestModels} service={this.state.active}
								  closeModal={this.closeModal}/>
					</Modal>
					<Modal id={"form-service"}>
						<FormService data={this.state.data} contratantes={this.state.contractors} update={this.requestModels}/>
					</Modal>
					<Modal id={"form-service-route"}>
						<FormServiceRoute data={this.state.data} contratantes={this.state.contractors} update={this.requestModels}/>
					</Modal>
					<Modal id={"form-model"}>
						<FormModel/>
					</Modal>
					<Modal id={"form-bus"}>
						<FormBus data={this.state.data}/>
					</Modal>
					<Modal id={"form-edit-bus"}>
						<FormEditBus data={this.state.data} update={this.requestModels} busId={this.state.busId}
									 modelId={this.state.modelId} closeModal={this.closeModal}/>
					</Modal>
					<Modal id={"form-edit-model"}>
						<FormEditModel update={this.requestModels} modelId={this.state.modelId}
									   closeModal={this.closeModal}/>
					</Modal>
					<Modal id={"form-contractor"}>
						<FormContractor/>
					</Modal>
					<Modal id={"form-edit-contractor"}>
						<FormEditContractor contratantes={this.state.contractors}/>
					</Modal>
				</div>
			</div>
		);
	}
}

App.childContextTypes = {
	setActive: React.PropTypes.func,
	getActive: React.PropTypes.func,
	getOpenId: React.PropTypes.func,
	setOpenId: React.PropTypes.func,
	getLp: React.PropTypes.func,
	getColor: React.PropTypes.func,
};

App.contextTypes = {
	router: React.PropTypes.object
};

export default DragDropContext(HTML5Backend)(App);



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/